
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PaymentFailedAlertProps {
  onRetry?: () => void;
  retryCount?: number;
}

export const PaymentFailedAlert = ({ 
  onRetry, 
  retryCount 
}: PaymentFailedAlertProps) => {
  return (
    <Alert variant="destructive" className="mb-8 max-w-3xl mx-auto">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Payment Failed</AlertTitle>
      <AlertDescription>
        <p className="mb-2">
          We couldn't process your payment. Please update your payment method or try again.
        </p>
        {onRetry && (
          <Button 
            onClick={onRetry} 
            size="sm" 
            variant="outline"
            className="mt-2"
          >
            Retry Payment
            {retryCount !== undefined && retryCount > 0 && ` (${retryCount})`}
          </Button>
        )}
      </AlertDescription>
    </Alert>
  );
};
